import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Timestamp } from 'firebase/firestore';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.scss'],
    standalone: false
})
export class DateTimePickerComponent implements OnInit {

  @Input() timestamp = Timestamp.fromDate(new Date(new Date().setSeconds(0)));
  @Output() timestampChange = new EventEmitter<any>();
  private _timestamp = this.timestamp.toDate()
  date = { year: this._timestamp.getFullYear(), month: this._timestamp.getMonth() + 1, day: this._timestamp.getDate() };
  time = { hour: this._timestamp.getHours(), minute: this._timestamp.getMinutes(), second: this._timestamp.getSeconds() };

  constructor() { }

  ngOnInit(): void {
  }
  update(){
    let fullDate;
    fullDate = new Date(this._timestamp.setFullYear(this.date.year, this.date.month - 1, this.date.day));
    fullDate.setHours(this.time.hour, this.time.minute, this.time.second)
    this.timestampChange.emit(Timestamp.fromDate(fullDate));
  }

}
